import { NuxtAppOptions } from '~/node_modules/@nuxt/types'

const pagesForRedirects = [
  '/docs/',
  '/docs/privacy-policy/',
  '/docs/sale-rules/',
]

export default function ({
  route,
  redirect,
}: {
  route: NuxtAppOptions
  redirect: (path: string) => void
}) {
  if (pagesForRedirects.includes(route.path)) {
    redirect(route.fullPath.replace('docs', 'info'))
  }
}
